// extracted by mini-css-extract-plugin
module.exports = {"root":"root__296LuD6r1RHa","avatar":"avatar__GZjBg2aruihz","scrollableList":"scrollableList__2HEBt_5fSSv4"};